import React from "react";
import { Nav } from "reactstrap";
import { useTranslate } from "hooks";
import cx from "classnames";
import { TabItem } from "./TabItem";
import {
  TechnicalDesignInputModes,
  useSetTechnicalDesignInputMode,
  useTechnicalDesignInputMode,
} from "stores/product";

type TechnicalPropertiesTab = {
  id: TechnicalDesignInputModes;
  labelKey: string;
};

const tabs: TechnicalPropertiesTab[] = [
  {
    id: TechnicalDesignInputModes.SINGLE_SELECTION,
    labelKey: "PRODUCT_SINGLE_SELECTION",
  },
  {
    id: TechnicalDesignInputModes.RESULT_LIST,
    labelKey: "PRODUCT_SUGGESTION",
  },
];

export const TechnicalPropertiesTabs = () => {
  const setTechnicalDesignInputMode = useSetTechnicalDesignInputMode();
  const technicalDesignInputMode = useTechnicalDesignInputMode();
  const translate = useTranslate();

  return (
    <Nav tabs className={cx("w-100 d-flex border-0")}>
      {tabs.map((tab) => (
        <TabItem
          key={tab.id}
          tabId={tab.id}
          label={translate(tab.labelKey)}
          isActive={technicalDesignInputMode === tab.id}
          onClick={() => setTechnicalDesignInputMode(tab.id)}
        />
      ))}
    </Nav>
  );
};
